import { render } from "./LeituraBiblicaDiariaTermsAndConditionsPT.vue?vue&type=template&id=31ee47b8"
import script from "./LeituraBiblicaDiariaTermsAndConditionsPT.vue?vue&type=script&lang=js"
export * from "./LeituraBiblicaDiariaTermsAndConditionsPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__